import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { stringify } from 'qs';
import { map, Observable } from 'rxjs';
import { extractStrapiData } from '../../helpers';
import {
  ClientLight,
  StrapiPageResponse,
  StrapiQueryParams,
} from '../../models';

@Injectable({ providedIn: 'root' })
export class ClientService {
  private readonly http = inject(HttpClient);
  private readonly url = 'api/clients';

  private readonly defaultQueryParams: StrapiQueryParams = {
    fields: ['id', 'documentId', 'name'],
    sort: ['name:asc'],
  };

  list(
    queryParams: StrapiQueryParams = this.defaultQueryParams,
  ): Observable<ClientLight[]> {
    const params = stringify(queryParams, { encodeValuesOnly: true });
    return this.http
      .get<StrapiPageResponse<ClientLight>>(`${this.url}?${params}`)
      .pipe(map((response) => extractStrapiData(response)));
  }
}
